import type { SupportedCurrency, CurrencyMeta } from '@/core/types/localization.types';

/**
 * Manual-override default exchange rates: 1 USD = X of target currency.
 * These are fallback seed values only — production deployments MUST
 * override via the rates API or admin settings panel (updated daily).
 */
export const EXCHANGE_RATES: Record<SupportedCurrency, number> = {
  USD: 1,
  INR: 83.5,
  EUR: 0.92,
  GBP: 0.79,
  AED: 3.67,
  SGD: 1.34,
  THB: 35.5,
  JPY: 149,
};

export const CURRENCY_META: Record<SupportedCurrency, CurrencyMeta> = {
  USD: { code: 'USD', symbol: '$', name: 'US Dollar', locale: 'en-US' },
  INR: { code: 'INR', symbol: '₹', name: 'Indian Rupee', locale: 'en-IN' },
  EUR: { code: 'EUR', symbol: '€', name: 'Euro', locale: 'de-DE' },
  GBP: { code: 'GBP', symbol: '£', name: 'British Pound', locale: 'en-GB' },
  AED: { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', locale: 'ar-AE' },
  SGD: { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar', locale: 'en-SG' },
  THB: { code: 'THB', symbol: '฿', name: 'Thai Baht', locale: 'th-TH' },
  JPY: { code: 'JPY', symbol: '¥', name: 'Japanese Yen', locale: 'ja-JP' },
};

export const TIMEZONE_OPTIONS = [
  { label: 'UTC (GMT+0:00)', value: 'UTC' },
  { label: 'Asia/Kolkata (GMT+5:30)', value: 'Asia/Kolkata' },
  { label: 'Asia/Dubai (GMT+4:00)', value: 'Asia/Dubai' },
  { label: 'Asia/Singapore (GMT+8:00)', value: 'Asia/Singapore' },
  { label: 'Asia/Tokyo (GMT+9:00)', value: 'Asia/Tokyo' },
  { label: 'Asia/Bangkok (GMT+7:00)', value: 'Asia/Bangkok' },
  { label: 'Europe/London (GMT+0:00)', value: 'Europe/London' },
  { label: 'Europe/Paris (GMT+1:00)', value: 'Europe/Paris' },
  { label: 'Europe/Berlin (GMT+1:00)', value: 'Europe/Berlin' },
  { label: 'US/Eastern (GMT-5:00)', value: 'US/Eastern' },
  { label: 'US/Central (GMT-6:00)', value: 'US/Central' },
  { label: 'US/Pacific (GMT-8:00)', value: 'US/Pacific' },
  { label: 'Australia/Sydney (GMT+11:00)', value: 'Australia/Sydney' },
];

export const CURRENCY_OPTIONS = Object.values(CURRENCY_META).map((c) => ({
  label: `${c.code} (${c.name})`,
  value: c.code,
}));
